export const formatCurrency = ({
  amount,
  currency = 'GBP',
  locale = 'en-GB',
}: {
  amount?: number
  currency?: string
  locale?: string
}) => {
  if (amount === null || amount === undefined) return ''

  // Convert from cents to standard currency units
  const standardAmount = amount / 100

  return new Intl.NumberFormat(locale, {
    currency,
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    style: 'currency',
  }).format(standardAmount)
}
